import Image from "next/image";

export type CreatorEstimationSectionPropType = {
  langFile: string;
  data: {
    type: string;
    list: {
      icon: string;
      heading: string;
      subheading: string;
    }[];
  };
};

const CreatorEstimationSection = ({
  langFile,
  data,
}: CreatorEstimationSectionPropType) => {
  return (
    <div className="relative overflow-hidden bg-estimation-section py-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4  gap-12 px-4 lg:px-[88px] max-w-[1440px] mx-auto">
        {data?.list.map((item, idx) => (
          <div
            key={idx}
            className="rounded-xl border border-grey-2 bg-white p-3 flex-1"
          >
            <div className="flex gap-3">
              <Image src={item.icon} alt={""} width={56} height={56} />
              <div>
                <p className="text-xl font-semibold">{item.heading}</p>
                <p className="text-base font-normal">{item.subheading}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreatorEstimationSection;
